import React from 'react';

import { observer } from 'mobx-react';

import ChatListItem from '../chat-list-item/chat-list-item';
import { useChatStore } from '../stores/use-chat-store';

const ChatList = observer(() => {
	const { chatStore } = useChatStore();
	const conversations = chatStore.getConversations;

	return (
		<div className="chat-list">
			{conversations.map(conversation => (
				<ChatListItem key={conversation.id.toString()} conversation={conversation} />
			))}
		</div>
	);
});

export default ChatList;
